import React from 'react';
import LayoutWrapper from '../../components/utility/layoutWrapper';
import { CloseOutlined } from '@ant-design/icons';
import CreateTaskHeader from '../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';

const ExternalIdSetupDrawer = ({ closeDrawer, data }) => {
    const externalId = data?.externalId || '<your-external-id>';

    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 24px',
        borderBottom: '1px solid #f0f0f0',
        background: '#fff'
    };

    const titleStyle = {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f1f1f',
        margin: 0
    };

    const closeIconStyle = {
        cursor: 'pointer',
        fontSize: '16px',
        color: '#666',
        padding: '4px'
    };

    const contentStyle = {
        padding: '24px',
        fontFamily: 'Nunito Sans',
        overflowY: 'auto',
        height: 'calc(100vh - 85px)'
    };

    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent="External ID Setup Guide" onCancel={closeDrawer} />

            <div style={{ marginTop: "84px", width: "100%" }} />
            {/* Header */}
            {/* <div style={headerStyle}>
                <h2 style={titleStyle}>External ID Setup Guide</h2>
                <CloseOutlined style={closeIconStyle} onClick={closeDrawer} />
            </div> */}

            {/* Content */}
            <div style={contentStyle}>
                <div style={{ 
                    marginBottom: '20px', 
                    padding: '16px', 
                    backgroundColor: '#e6f7ff', 
                    borderRadius: '8px',
                    borderLeft: '4px solid #1890ff'
                }}>
                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6' }}>
                        The External ID is a security feature that adds an extra layer of protection when assuming IAM roles. 
                        Follow the steps below to configure it in your AWS IAM role's trust relationship.
                    </p>
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <h3 style={{ 
                        fontFamily: 'Poppins', 
                        fontSize: '16px', 
                        fontWeight: '600',
                        marginBottom: '16px',
                        color: '#1f1f1f'
                    }}>
                        Step-by-Step Configuration:
                    </h3>
                    
                    <ol style={{ 
                        paddingLeft: '20px', 
                        fontSize: '14px',
                        lineHeight: '1.8'
                    }}>
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Copy the External ID</strong>
                            <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                                Copy the External ID displayed in the form field above
                            </p>
                        </li>
                        
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Navigate to AWS IAM Console</strong>
                            <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                                Go to AWS Console → IAM → Roles → Select your role
                            </p>
                        </li>
                        
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Access Trust Relationships</strong>
                            <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                                Click on the "Trust relationships" tab
                            </p>
                        </li>
                        
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Edit Trust Policy</strong>
                            <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                                Click "Edit trust policy" button
                            </p>
                        </li>
                        
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Add External ID Condition</strong>
                            <p style={{ margin: '4px 0 8px 0', color: '#666' }}>
                                Add the following condition to the Statement array in your trust policy:
                            </p>
                            <pre style={{ 
                                background: '#f5f5f5', 
                                padding: '16px', 
                                borderRadius: '6px',
                                fontSize: '13px',
                                overflow: 'auto',
                                border: '1px solid #d9d9d9',
                                fontFamily: 'Monaco, Courier, monospace'
                            }}>
{`"Condition": {
  "StringEquals": {
    "sts:ExternalId": "${externalId}"
  }
}`}
                            </pre>
                        </li>
                        
                        <li style={{ marginBottom: '16px' }}>
                            <strong>Save Changes</strong>
                            <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                                Click "Update policy" to save your changes
                            </p>
                        </li>
                    </ol>
                </div>

                <div style={{ 
                    padding: '16px', 
                    backgroundColor: '#fff7e6', 
                    borderRadius: '8px',
                    borderLeft: '4px solid #faad14'
                }}>
                    <h4 style={{ 
                        fontFamily: 'Poppins',
                        fontSize: '14px',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#1f1f1f'
                    }}>
                        Complete Trust Policy Example:
                    </h4>
                    <pre style={{ 
                        background: '#fff', 
                        padding: '12px', 
                        borderRadius: '6px',
                        fontSize: '12px',
                        overflow: 'auto',
                        margin: '8px 0 0 0',
                        border: '1px solid #d9d9d9',
                        fontFamily: 'Monaco, Courier, monospace'
                    }}>
{`{
  "Version": "2012-10-17",
  "Statement": [
    {
      "Effect": "Allow",
      "Principal": {
        "AWS": "arn:aws:iam::ACCOUNT-ID:root"
      },
      "Action": "sts:AssumeRole",
      "Condition": {
        "StringEquals": {
          "sts:ExternalId": "${externalId}"
        }
      }
    }
  ]
}`}
                    </pre>
                </div>

                <div style={{ 
                    marginTop: '24px',
                    padding: '12px', 
                    backgroundColor: '#f0f0f0', 
                    borderRadius: '6px',
                    fontSize: '13px',
                    color: '#666'
                }}>
                    <strong>Note:</strong> The External ID enhances security by preventing the "confused deputy problem" 
                    in cross-account role assumption scenarios.
                </div>
            </div>
        </LayoutWrapper>
    );
};

export default ExternalIdSetupDrawer;

